import { render } from "./DropdownArrow.vue?vue&type=template&id=233e6e68"
import script from "./DropdownArrow.vue?vue&type=script&lang=js"
export * from "./DropdownArrow.vue?vue&type=script&lang=js"

import exportComponent from "/Users/elisabetta/Code/salvi-rental/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__